export default __webpack_public_path__ + "static/media/lobby.4c9e50fb.png";